import { useState } from "react";
import orbitImg from "../Images/orbit.png";
import { FaEnvelope, FaLock } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
  const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

  const login = () => {
    if (
      form.email === ADMIN_EMAIL &&
      form.password === ADMIN_PASSWORD
    ) {
      localStorage.setItem("token", "admin-auth-token");
      navigate("/admin");
    } else {
      alert("Invalid login");
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 px-4 -mt-10">
      <div className="bg-white p-8 rounded-2xl shadow-2xl w-full max-w-[410px]">
        
        <div className="flex justify-center mb-4">
          <img src={orbitImg} alt="logo" className="h-[100px]" />
        </div>

        <h2 className="text-3xl font-bold mb-6 text-center text-[#0b0675]">
          Admin Login
        </h2>

        <div className="relative mb-4">
          <FaEnvelope className="absolute left-3 top-4 text-gray-500" />
          <input
            type="email"
            placeholder="Enter your email"
            className="border w-full p-2.5 pl-10 rounded"
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />
        </div>

        <div className="relative mb-4">
          <FaLock className="absolute left-3 top-4 text-gray-500" />
          <input
            type="password"
            placeholder="Enter Password"
            className="border w-full p-2.5 pl-10 rounded"
            onChange={(e) =>
              setForm({ ...form, password: e.target.value })
            }
          />
        </div>

        <button
          onClick={login}
          className="bg-[#0e0469] text-white w-full p-2.5 text-xl rounded-lg"
        >
          Login
        </button>
      </div>
    </div>
  );
}